import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["advancedPanel", "filterBadge", "searchForm"]

  connect() {
    this.updateFilterBadge()
  }

  toggleAdvancedSearch(event) {
    event.preventDefault()
    
    if (!this.hasAdvancedPanelTarget) return

    const panel = this.advancedPanelTarget
    const isOpen = panel.classList.contains("is-open") || panel.style.display === "block"

    // Remove active class from all buttons
    const buttons = this.element.querySelectorAll('.right-actions .btn')
    buttons.forEach(btn => btn.classList.remove('active'))

    if (isOpen) {
      panel.classList.remove("is-open")
      panel.style.display = "none"
    } else {
      panel.classList.add("is-open")
      panel.style.display = "block"
      if (event.currentTarget) event.currentTarget.classList.add('active')
    }
  }

  clearFilters(event) {
    event.preventDefault()
    
    const form = this.hasSearchFormTarget 
      ? this.searchFormTarget 
      : this.hasAdvancedPanelTarget 
        ? this.advancedPanelTarget.querySelector('form')
        : this.element.querySelector('form')
    
    if (!form) return
    
    // Clear all inputs except sort and direction
    form.querySelectorAll('input[type="text"], input[type="number"]').forEach(input => {
      const name = input.getAttribute('name')
      if (name !== 'sort' && name !== 'direction' && name !== 'search_term') {
        input.value = ''
      }
    })
    
    // Reset selects to first option or 'all' value
    form.querySelectorAll('select').forEach(select => {
      // Check if there's an option with value 'all'
      const allOption = select.querySelector('option[value="all"]')
      if (allOption) {
        select.value = 'all'
      } else {
        select.selectedIndex = 0
      }
    })
    
    // Uncheck checkboxes
    form.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = false
    })
    
    // Hide custom stock input if visible
    const stockCustomWrapper = document.getElementById('stock-custom-wrapper')
    if (stockCustomWrapper) {
      stockCustomWrapper.style.display = 'none'
    }
    
    // Update badge count
    this.updateFilterBadge()
    
    // Submit form
    form.requestSubmit()
  }

  updateFilterBadge() {
    if (!this.hasFilterBadgeTarget) return
    
    const form = this.hasSearchFormTarget 
      ? this.searchFormTarget 
      : this.hasAdvancedPanelTarget 
        ? this.advancedPanelTarget.querySelector('form')
        : this.element.querySelector('form')
    
    if (!form) {
      this.filterBadgeTarget.style.display = 'none'
      return
    }
    
    let count = 0
    
    // Count filled text/number inputs
    form.querySelectorAll('input[type="text"], input[type="number"]').forEach(input => {
      const name = input.getAttribute('name')
      
      // Skip certain fields
      if (name === 'sort' || name === 'direction' || name === 'search_term') return
      
      // For stock_value, only count if stock is set to 'custom'
      if (name === 'stock_value') {
        const stockSelect = form.querySelector('select[name="stock"]')
        if (!stockSelect || stockSelect.value !== 'custom') return
      }
      
      if (input.value && input.value.trim() !== '') {
        count++
      }
    })
    
    // Count selected dropdowns (excluding 'all')
    form.querySelectorAll('select').forEach(select => {
      const name = select.getAttribute('name')
      if (name !== 'sort' && name !== 'direction') {
        if (select.value && select.value !== 'all' && select.value !== '') {
          count++
        }
      }
    })
    
    // Count checked checkboxes
    const checkboxes = form.querySelectorAll('input[type="checkbox"]:checked')
    count += checkboxes.length
    
    // Update badge
    const badge = this.filterBadgeTarget
    if (count > 0) {
      badge.textContent = count
      badge.style.display = 'inline-flex'
    } else {
      badge.style.display = 'none'
    }
  }

  onStockChange(event) {
    const stockValue = event.target.value
    const customWrapper = document.getElementById('stock-custom-wrapper')
    
    if (customWrapper) {
      customWrapper.style.display = stockValue === 'custom' ? 'block' : 'none'
    }
    
    this.updateFilterBadge()
  }
}
